export const ItemTypes = {
  BOX: 'BOX',
  TEXT: 'TEXT',
}
